import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17a02b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mxa-help-title pt-2",
  "data-test": "title"
}
const _hoisted_2 = { class: "mxa-help-body" }
const _hoisted_3 = { class: "mxa-help-body" }
const _hoisted_4 = { class: "mxa-help-body" }
const _hoisted_5 = {
  key: 0,
  "data-test": "msg1_other_ja"
}
const _hoisted_6 = { style: {"padding-top":"0.5rem"} }

import BaseAccordion from '@/components/common/parts/BaseAccordion.vue'
import HelpLicense from '@/components/help/HelpLicense.vue'
import { useStore } from '@/store'
import { LANG_TYPE } from '@/i18n/langType'


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpService',
  setup(__props) {

const store = useStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('body.help.service.title')), 1),
    _createVNode(BaseAccordion, {
      accordionId: "helpService1",
      headerTitle: _ctx.$t('body.help.service.1.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.service.1.body.1')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.service.1.body.2')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.service.1.body.3')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"]),
    _createVNode(BaseAccordion, {
      accordionId: "helpService2",
      headerTitle: _ctx.$t('body.help.service.2.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.service.2.body.1')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.service.2.body.2')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"]),
    _createVNode(BaseAccordion, {
      accordionId: "helpService3",
      headerTitle: _ctx.$t('body.help.service.3.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.service.3.body.1')), 1),
          (!_unref(store).getters.isJapanese)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('body.agree.message1-other-ja')), 1))
            : _createCommentVNode("", true),
          _createVNode(HelpLicense, {
            language: _unref(store).getters.language
          }, null, 8, ["language"]),
          (!_unref(store).getters.isJapanese)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('body.help.service.3.body.ja-original')), 1),
                _createVNode(HelpLicense, {
                  language: _unref(LANG_TYPE).JA
                }, null, 8, ["language"])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"])
  ], 64))
}
}

})